import React from 'react'
import { useLocation } from "react-router-dom"

import { Layout, Form, Input, Button, Select, Card, Row, Col, Breadcrumb } from 'antd'

import { useStore } from '../../contexts/FireStoreContext'
import { convertToSlug, getBaseUrl } from '../../utils/browser'
import countries, { countryNameByIso2 } from "../../data/countries"
import { bankTypes } from "../../data/banks"

const { Content } = Layout

const { Option } = Select

const table = "banks"

const Add = () => {
  const [form] = Form.useForm()
  const { addDocument } = useStore()
  const { pathname } = useLocation()

  const onFinish = data => {

    const payload = {
      ...data,
      slug: convertToSlug(data.bank),
      country: countryNameByIso2(data.iso2)
    }
    // console.log(payload)
    addDocument(table, payload, payload.name, getBaseUrl(pathname))
  }

  const onFinishFailed = data => console.log(data)

  return (
    <Content>
      <Breadcrumb>
        <Breadcrumb.Item>Banks</Breadcrumb.Item>
        <Breadcrumb.Item>Add</Breadcrumb.Item>
      </Breadcrumb>
      <Row>
        <Col md={8}>
          <Card title="Add Bank">
            <Form
              // name="add"
              form={form}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                className="mb-2"
                label="Bank Name"
                name="bank"
                rules={[{ required: true, message: 'Bank Name is required' }]}
              >
                <Input
                  placeholder="Bank Name"
                />
              </Form.Item>
              <Form.Item
                className="mb-2"
                // required
                label="Bank/Union"
                name="type"
                rules={[{ required: true, message: 'This Field is required' }]}
              >
                <Select
                  showSearch
                  placeholder="Select Type"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {bankTypes?.map(option => (
                    <Option key={option.value} value={option.value}>{option.label}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                className="mb-2"
                // required
                label="Country"
                name="iso2"
                rules={[{ required: true, message: 'Country is required' }]}
              >
                <Select
                  showSearch
                  placeholder="Select Country"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {countries?.map(option => (
                    <Option key={option.iso2} value={option.iso2}>{option.name}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item className="pt-2">
                <Row justify="end">
                  <Col>
                    <Button
                      type="primary"
                      htmlType="submit"
                    >
                      Add
                    </Button>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Content>
  )
}

export default Add
